import { useFormikContext } from 'formik';
import React from 'react';
import styled, { keyframes } from 'styled-components';

import Loading from '../../icons/loading.svg';

const SubmitButton = (props) => {
  const formikContext = useFormikContext();
  const { children } = props;
  const { isSubmitting } = formikContext;

  return (
    <StyledButton
      type="submit"
      disabled={isSubmitting}
      isSubmitting={isSubmitting}
    >
      {isSubmitting && <LoadingIcon />}
      {children}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  appearance: none;
  border: none;
  padding: 0px 30px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: none;
  background: linear-gradient(#3eaaf0, #057fce);

  color: ${({ isSubmitting }) => (isSubmitting ? 'transparent' : 'white')};
  box-shadow: 0px 1px 3px rgba(153, 155, 162, 0.15);
  cursor: pointer;
  text-decoration: none;

  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 4px;
    background: linear-gradient(var(--blue-light), rgb(5, 107, 174));

    opacity: 0;
    transition: opacity 0.2s ease-out;
    z-index: -1;
  }

  &:hover::before {
    opacity: 1;
  }

  &:focus {
    box-shadow: 0 0 0 4px rgba(5, 127, 206, 0.25);
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  } 
  to {
    transform: rotate(360deg);
  }
`;

const LoadingIcon = styled(Loading)`
  position: absolute;
  animation: ${rotate} 0.5s linear infinite;
  path {
    fill: white;
  }
`;

export default SubmitButton;
